import type { ExtractPropTypes, PropType } from '@vue/composition-api'

const props = {
  fileId: {
    type: [Number, String],
    default: '0'
  },
  isMobile: {
    type: Boolean,
    default: false
  },
  afterAppeal: {
    type: Function as PropType<(...args: Array<any>) => any>,
    default: () => {}
  }
}

export type illegalAppealPropsType = ExtractPropTypes<typeof props>

export default props
